import './SkeletonLoader.css';

function SkeletonLoader() {
  return (
    <div style={styles.container}>
      <div style={{...styles.skeleton}} className="skeleton-pulse" />
    </div>
  );
}

const styles = {
  container: {
    padding: '20px',
    textAlign: 'center',
  },
  skeleton: {
    width: '80%',
    height: '20px',
    margin: '10px auto',
    backgroundColor: '#e0e0e0',
    borderRadius: '4px',
  },
};

export default SkeletonLoader;